import type { FlexProps } from '@mantine/core';
import { Flex } from '@mantine/core';

import styles from './ListItem.module.css';

export const LBListItem = ({ children, ...props }: FlexProps) => (
  <Flex {...props} className={styles.container}>
    {children}
  </Flex>
);
